import { AlertsDesktopView } from './AlertsDesktopView';

export function AlertsTabletView() {
  return <AlertsDesktopView />;
}
